import { gql } from '@apollo/client';

export const LIST_DOCUMENTS_AVAILABILITY = gql`
  query ListDocuments($filter: DocumentFilterInput!) {
    listDocuments(filter: $filter) {
      items {
        id
        case_id
        availability {
          embeddings
        }
        metadata {
          filename
          type
          subtype
        }
      }
    }
  }
`;
